"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var _callback, _cachedValue;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CachedValue = void 0;
/**
 * Lazy readonly value, is being calculated on first access only using constructor supplied callback.
 */
class CachedValue {
    /**
     * Construct cached value specifying calculation callback. Note that it is possible to cache a Promise
     * for example using async callback and it will not be started until first access.
     * @param cb
     */
    constructor(cb) {
        _callback.set(this, void 0);
        _cachedValue.set(this, void 0);
        __classPrivateFieldSet(this, _callback, cb);
    }
    /**
     * Drop cached value it will be recalculated on next call to [[value]].
     */
    clear() {
        __classPrivateFieldSet(this, _cachedValue, undefined);
    }
    /**
     * Calculate if need or return cached value returned by the lambda passed to the constructor.
     */
    get value() {
        if (__classPrivateFieldGet(this, _cachedValue) == undefined)
            __classPrivateFieldSet(this, _cachedValue, __classPrivateFieldGet(this, _callback).call(this));
        return __classPrivateFieldGet(this, _cachedValue);
    }
}
exports.CachedValue = CachedValue;
_callback = new WeakMap(), _cachedValue = new WeakMap();
//# sourceMappingURL=CachedValue.js.map